import type { TableSemanticSchema } from './types';

export const ImpactEffortSchema: TableSemanticSchema = {
  id: 'impact-effort',
  name: 'Impact vs. Effort Matrix',
  description:
    '2×2 prioritization matrix. Quick wins (high impact, low effort) bubble to the top of the backlog.',
  cells: [
    { id: 'quick_wins', label: 'Quick Wins — High Impact, Low Effort', row: 0, col: 0, accent: '#16a34a' },
    { id: 'major_projects', label: 'Major Projects — High Impact, High Effort', row: 0, col: 1, accent: '#2563eb' },
    { id: 'fill_ins', label: 'Fill-Ins — Low Impact, Low Effort', row: 1, col: 0, accent: '#64748b' },
    { id: 'thankless', label: 'Thankless Tasks — Low Impact, High Effort', row: 1, col: 1, accent: '#dc2626' },
  ],
  itemFields: [
    { key: 'impact', label: 'Impact', kind: 'number', required: true, description: '1 (low) to 5 (high)' },
    { key: 'effort', label: 'Effort', kind: 'number', required: true, description: '1 (low) to 5 (high)' },
    { key: 'quadrant', label: 'Quadrant', kind: 'enum',
      options: [
        { value: 'quick_wins', label: 'Quick Wins' },
        { value: 'major_projects', label: 'Major Projects' },
        { value: 'fill_ins', label: 'Fill-Ins' },
        { value: 'thankless', label: 'Thankless Tasks' },
      ] },
  ],
  renderingHints: { layout: 'quadrant' },
};
